import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { config } from "../../../base/constant";

export const supportApi = createApi({
    reducerPath: "supportApi",
    baseQuery: fetchBaseQuery({
         baseUrl:config().BASE_URL,
         prepareHeaders: (headers: any) => {
            headers.set("Authorization", `Token ${localStorage.getItem("token")}`);
            return headers
        }
        }),
    tagTypes: ['support'],
    endpoints: (builder) => ({
        addSupport: builder.mutation<any,any>({
            query: (supportInfo) => ({
                url: "/customer-support/",
                method: "POST",
                body:supportInfo,
            }),
            invalidatesTags:['support']
        }),
        getTypeOfQuerys:builder.query<any, void>({
            query: () => ({
                url: "/query-type/",
                method: "GET",
            }),
            providesTags: ['support']
        }),
        getSupportList:builder.query<any,void>({
            query:()=>({
                url: "/service-request/",
                method: "GET",
            }),
            providesTags: ['support']
        }),
        getSupportTicketList:builder.query<any,void>({
            query:()=>({
                url: "/customer-support/",
                method: "GET",
                params: {
                    status: "Inprocess" 
                },
                
            }),
            providesTags: ['support']
        }),
        getRemarks:builder.query<any,any>({
            query:(id)=>({
                url: `/service-request/remark/?service_request_id=${id}`,
                method: "GET",
            }),
            providesTags: ['support']
        }),
        getAttachments:builder.query<any,any>({
            query:(id)=>({
                url: `/service-request/attachment/?service_request_id=${id}`,
                method: "GET",
            }),
            providesTags: ['support']
        }),
        postRemark:builder.mutation<any,any>({
            query:({id, data})=>({
                url: `/service-request/remark/?service_request_id=${id}`,
                method: "POST",
                body: data
            }),
            invalidatesTags:['support']
        }),
        postAttachment:builder.mutation<any,any>({
            query:({id, data})=>({
                url: `/service-request/attachment/?service_request_id=${id}`,
                method: "POST",
                body: data
            }),
            invalidatesTags:['support']
        }),
        syncTrackCase:builder.mutation<any,void>({
            query:()=>({
                url: `/customer-support/track_cases/?refresh=true`,
                method: "GET",
            }),
            invalidatesTags:['support']
        }),
        submitCancellation: builder.mutation<any, any>({
            query: (cancellationData) => ({
                url: "/cancellation-submit/",
                method: "POST",
                body: cancellationData,
            }),
            invalidatesTags: ['support']
        }),
    }),
});

export const { useAddSupportMutation, useGetTypeOfQuerysQuery, useGetSupportListQuery, useGetSupportTicketListQuery, useGetRemarksQuery, useGetAttachmentsQuery, usePostRemarkMutation, usePostAttachmentMutation, useSyncTrackCaseMutation, useSubmitCancellationMutation } = supportApi;

